import React, { useState, useEffect } from "react";
import "./App.css";
import { MDBSpinner } from "mdb-react-ui-kit";
import { Toast, ToastContainer, ProgressBar } from "react-bootstrap";

export default function Modal({
  style,
  receiptModal,
  explorer,
  hash,
  getProgress,
  time,
}) {
  const [optSmModal, setOptSmModal] = useState(false);
  let [counter, setCounter] = useState(0);
  const [progress, setProgress] = useState(100);

  const toggleShow = () => setOptSmModal(!optSmModal);

  const timer = (ms) => new Promise((res) => setTimeout(res, ms));

  const startProgress = async () => {
    setProgress(100);
    for (let x = 100; x > 0; x--) {
      await timer(time * 10);
      setProgress(x);
    }
    setProgress(0);
    setOptSmModal(false);
  };

  useEffect(() => {
    if (counter > 0) {
      setOptSmModal(true);
      startProgress();
    } else {
      setOptSmModal(false);
      setCounter(counter + 1);
    }
  }, [getProgress]);

  return (
    <>
      <div>
        <ToastContainer className="p-3" position={"top-end"} bg={"dark"}>
          <Toast
            show={optSmModal}
            bg={"dark"}
            className={`text-${style}`}
            onClose={toggleShow}
          >
            <Toast.Body>
              <div className="flex">
                <MDBSpinner
                  grow
                  size="sm"
                  role="status"
                  tag="span"
                  className="me-2"
                />

                <strong
                  title="View Transaction Details"
                  className={`text-${style} link`}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(`${explorer}tx/${hash}`, "_blank");
                  }}
                >
                  {" "}
                  {receiptModal}
                </strong>
              </div>
              <br />
              <ProgressBar now={progress} variant={style} />
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}
